// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentPart{
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.comingSoonTitle{
    color: #CD3636;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
}

.comingSoonQuestion{
    color: #1D1E2599;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
}

.restaurant-buttons-container{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.company-select-buttons{
background-color: #F1F5F7;
display: flex;
justify-content: space-evenly;
padding: 8px;
border-radius: 10px;
width: 95%;

}
.company-select-button.active{
    background-color: white;
    font-weight: bold !important;
    color: #1D1E25;
    border-radius: 8px;
    font-size: 16px;
}

.company-select-buttons button {
    background-color: transparent;
    color: #1D1E2599;
    border: none;
    font-weight: 200;
    font-size: 16px;
    line-height: 26px;
    padding: 12px 32px;
    width: 202px;
    height: 50px;
}
.company-select-buttons a{
    color: #1D1E2599;
    text-decoration: none;
    font-weight: 400;
    border-radius: 6px;
    padding: 10px;
}

.company-select-buttons a:focus{
    background-color: #FFFF;
    border-radius: 6px;
    color: #1D1E25;
    font-weight: 400;
    font-size: 16px;
}

.restaurant-update-screen-titles{
    margin-top: 45px;
    margin-bottom: 25px;
    font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/cominSoonStyles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;AACA,yBAAyB;AACzB,aAAa;AACb,6BAA6B;AAC7B,YAAY;AACZ,mBAAmB;AACnB,UAAU;;AAEV;AACA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".contentPart{\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.comingSoonTitle{\n    color: #CD3636;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 34px;\n}\n\n.comingSoonQuestion{\n    color: #1D1E2599;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n}\n\n.restaurant-buttons-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n.company-select-buttons{\nbackground-color: #F1F5F7;\ndisplay: flex;\njustify-content: space-evenly;\npadding: 8px;\nborder-radius: 10px;\nwidth: 95%;\n\n}\n.company-select-button.active{\n    background-color: white;\n    font-weight: bold !important;\n    color: #1D1E25;\n    border-radius: 8px;\n    font-size: 16px;\n}\n\n.company-select-buttons button {\n    background-color: transparent;\n    color: #1D1E2599;\n    border: none;\n    font-weight: 200;\n    font-size: 16px;\n    line-height: 26px;\n    padding: 12px 32px;\n    width: 202px;\n    height: 50px;\n}\n.company-select-buttons a{\n    color: #1D1E2599;\n    text-decoration: none;\n    font-weight: 400;\n    border-radius: 6px;\n    padding: 10px;\n}\n\n.company-select-buttons a:focus{\n    background-color: #FFFF;\n    border-radius: 6px;\n    color: #1D1E25;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.restaurant-update-screen-titles{\n    margin-top: 45px;\n    margin-bottom: 25px;\n    font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
